/**
 * Created by andreyna on 6/13/2016.
 */
import BaseModelComponent from '../../../base/base_model_component';
import {VOUCHER_STATE, IAlteredFreePlayVoucher} from './free_play_voucher_consts';
import FPVouchersComponentController from '../vouchers/fp_vouchers_component_controller';

export default class FreePlayVoucherComponentModel extends BaseModelComponent {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'FreePlayVoucherComponentModel';

    private _voucher: IAlteredFreePlayVoucher;

    private _state: string;

    private _containerRef: FPVouchersComponentController;

    /**
     *
     * @param params
     */
    init(params: any = {}) {
        super.init(params);
        this._setVoucher(params.voucher)
             .setState(params.state)
            ._setContainerRef(params.container);
    }


    /**
     * Set voucher object
     * @param voucher
     * @returns {FreePlayVoucherComponentModel}
     * @private
     */
    private _setVoucher(voucher) {
        this._voucher = voucher;
        return this;
    }


    /**
     * Set voucher state, default is init
     * @param state
     * @returns {FreePlayVoucherComponentModel}
     * @private
     */
    setState(state = VOUCHER_STATE.INIT) {
        this._state = state;
        return this;
    }


    /**
     * Set reference for voucher container object
     * @param container
     * @returns {FreePlayVoucherComponentModel}
     * @private
     */
    private _setContainerRef(container) {
        this._containerRef = container;
        return this;
    }


    /**
     * Get voucher
     * @returns {*}
     */
    getVoucher() {
        return this._voucher;
    }


    /**
     * Get voucher state
     * @returns {string|*}
     */
    getState() {
        return this._state;
    }

    getContainerRef() {
        return this._containerRef;
    }
}
